import React from 'react'

import { UserInitial } from '@/components/UserInitial'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

export const AgentList = ({ agents }) => {
  return (
    <InteractiveTooltip
      content={
        <div className="text-left">
          {agents.map((agent) => (
            <div key={agent.value}>{agent.label}</div>
          ))}
        </div>
      }
    >
      <div>
        {agents
          .filter((agent, index) => index < 3)
          .map((agent, index) => (
            <UserInitial userFullName={agent.label} index={index} inline key={agent.value} />
          ))}
        {agents.length > 3 && <UserInitial overflowCount={agents.length - 3} inline />}
      </div>
    </InteractiveTooltip>
  )
}
